export default __webpack_public_path__ + "static/media/case_study_renault.30eec9de.mp4";